import {Typography, Select, Input} from 'antd';
import CardItem from './CardItem';
const {Text} = Typography;

const DiscountSection = ({
  discountConfig,
  updateDiscountConfig,
  maxDiscountPercentage,
  isDiscountOverLimit,
  maxDiscountAmount,
  currencySymbol,
}) => {
  const hasCap = !!maxDiscountPercentage;
  return (
    <CardItem>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Text
          style={{
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '16px',
            color: '#1F2D3D',
          }}
        >
          Discount
        </Text>
        {hasCap && (
          <Text style={{fontSize: '12px', color: '#8492A6'}}>
            Max {maxDiscountPercentage}% of cart value
          </Text>
        )}
      </div>
      <div
        style={{
          display: 'flex',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        <Select
          placeholder="Select Discount"
          options={[
            {value: 'percentage', label: 'Percentage'},
            {value: 'flat', label: 'Flat'},
            {value: 'static', label: 'Discount Code'},
          ]}
          style={{width: '100%'}}
          value={discountConfig.type}
          onChange={value => {
            updateDiscountConfig('type', value);
          }}
        />
        <Input
          placeholder="Enter Discount"
          value={discountConfig.discountValue}
          status={isDiscountOverLimit ? 'error' : ''}
          onChange={e => {
            updateDiscountConfig('discountValue', e.target.value);
          }}
          suffix={discountConfig.type === 'percentage' ? <Text>%</Text> : null}
        />
        {isDiscountOverLimit && (
          <p
            style={{
              margin: '0px',
              fontSize: '12px',
              color: '#ff4d4f',
              width: '100%',
            }}
          >
            Discount cannot exceed {maxDiscountPercentage}% of cart value
            {maxDiscountAmount
              ? ` (${currencySymbol || ''}${maxDiscountAmount})`
              : ''}
            .
          </p>
        )}
        {discountConfig.type === 'static' && (
          <p style={{fontStyle: 'italic', margin: '0px', fontSize: '12px'}}>
            Discount will be applied automatically during checkout
            {hasCap
              ? `. A code worth more than ${maxDiscountPercentage}% of cart value will be rejected`
              : ''}
          </p>
        )}
      </div>
    </CardItem>
  );
};

export default DiscountSection;
